export const NotFoundPage = () => {
  return (
    <h1>
      Упс! Что-то пошло не так, посмотрите в адресную строку или перезагрузите
      страничку :)
    </h1>
  );
};
